// extracted by mini-css-extract-plugin
export default {"NavLink":"NavLinkItem_NavLink__pA0xn","NavLinkActive":"NavLinkItem_NavLinkActive__I-wcw"};